module.exports = __webpack_public_path__ + "img/sup_deposit_mtpay3.707ac85c.jpg";